import React from 'react';
import { useAppSelector } from '../../store/hooks';
import { Spin } from 'antd';
import './PersonPhoto.less';
import usePermissions from '../../lib/utils/usePermissions';
import { PERSON_READ_FULLACCESS } from '../../lib/const/permissions';

interface Props {
  myProfile: boolean;
  image: any;
  mini?: boolean;
  isLoading?: boolean;
  heightPhoto?: number;
  widthPhoto?: number;
  children?: React.ReactNode;
}

function PersonPhoto(props: Props) {
  const { image, mini, isLoading, heightPhoto, widthPhoto, children } = props;
  const { personFullCard, meUserFull, personCard } = useAppSelector((state) => state.persons);
  const [hasAccess] = usePermissions();

  const isMinAccess = !hasAccess([PERSON_READ_FULLACCESS]);
  const personData = isMinAccess ? personCard : personFullCard;

  const profile = props.myProfile ? meUserFull : personData;
  const size = {
    height: heightPhoto || (mini ? '42px' : '217px'),
    width: widthPhoto || (mini ? '42px' : '217px'),
  };

  return (
    <div className="person_photo_container">
      <Spin spinning={isLoading}>
        <div
          style={{
            width: size.width,
            height: size.height,
            borderRadius: '10px',
            backgroundColor: '#7F5A5A',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          {image ? (
            <img
              alt="img"
              src={`data:image/jpeg;base64,${image}`}
              height={size.height}
              width={size.width}
              style={{
                borderRadius: '10px',
              }}
            />
          ) : (
            <span
              style={{
                fontSize: mini ? '25px' : '120px',
                color: 'white',
                alignSelf: 'center',
              }}
            >
              {profile && profile.firstName && profile.firstName.charAt(0)}
            </span>
          )}
          {children}
        </div>
      </Spin>
    </div>
  );
}

export default PersonPhoto;
